import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Stat } from '@/components/ui/Stat';
import { useDashboardStats } from '@/hooks/useAdminMonitoring';
import { formatNumber, formatPercentage } from '@/utils/formatters';
import { Users } from 'lucide-react';

export function ActiveUsersChart() {
  const { data } = useDashboardStats();
  const users = data?.users;

  return (
    <Card>
      <CardHeader title="Utilisateurs" icon={<Users className="h-4 w-4" />} />
      <CardContent>
        <div className="grid grid-cols-3 gap-3">
          <div className="rounded-xl bg-neutral-100 p-3 text-center transition-colors duration-200 hover:bg-neutral-200/70 dark:bg-neutral-800/50 dark:hover:bg-neutral-800/70">
            <p className="text-lg font-bold text-neutral-900 dark:text-neutral-100">{formatNumber(users?.activeNow)}</p>
            <p className="text-[10px] font-medium uppercase tracking-wider text-neutral-500">En ligne</p>
          </div>
          <div className="rounded-xl bg-neutral-100 p-3 text-center transition-colors duration-200 hover:bg-neutral-200/70 dark:bg-neutral-800/50 dark:hover:bg-neutral-800/70">
            <p className="text-lg font-bold text-success-400">{formatNumber(users?.newToday)}</p>
            <p className="text-[10px] font-medium uppercase tracking-wider text-neutral-500">Nouveaux (24h)</p>
          </div>
          <div className="rounded-xl bg-neutral-100 p-3 text-center transition-colors duration-200 hover:bg-neutral-200/70 dark:bg-neutral-800/50 dark:hover:bg-neutral-800/70">
            <p className="text-lg font-bold text-primary-400">{formatNumber(users?.total)}</p>
            <p className="text-[10px] font-medium uppercase tracking-wider text-neutral-500">Total</p>
          </div>
        </div>
        <Stat
          className="mt-3 border-0 bg-transparent p-0"
          label="Croissance"
          value={users?.growth != null ? formatPercentage(users.growth) : '--'}
          icon={<Users className="h-4 w-4" />}
        />
      </CardContent>
    </Card>
  );
}
